import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Constants from '../Constants';
import '../App.css';

function PaymentSuccessView() {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [sessionData, setSessionData] = useState(null);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	useEffect(() => {
		async function fetchSession() {
			try {
				const sessionId = searchParams.get('session_id');
				if(!sessionId) {
					setError('No session ID found.');
					setLoading(false);
					return;
				}

				const url = Constants.SERVER_URL + '/api/payment/confirm_session/' + sessionId;
				const response = await axios.get(url);
				if(response.data && response.data.confirmed) {
					localStorage.removeItem(Constants.SIGNUP_USER_EMAIL);
					localStorage.removeItem(Constants.SIGNUP_SELECTED_PLAN);
					setSessionData({ confirmed: true });
				}
				else {
					setError('Payment could not be confirmed. Please contact support.');
				}
			} catch (error) {
				setError('Failed to retrieve checkout session.');
				console.error('PaymentSuccessView - fetchSession error:', error.message);
			} finally {
				setLoading(false);
			}
		}
		fetchSession();
	}, [searchParams]);

	function handleContinue() {
		navigate('/login');
	}

	function renderLoading() {
		return (
			<div className="text-center">
				<Spinner animation="border" role="status" />
				<p className="mt-3" style={{ color: '#ccc' }}>Finalizing your subscription...</p>
			</div>
		);
	}

	function renderError() {
		if(!error) {
			return null;
		}
		return <Alert variant="danger" className="text-center">{error}</Alert>;
	}

	function renderSuccess() {
		if(!sessionData) {
			return null;
		}

		return (
			<div className="text-center">
				<h4 style={{ color: '#00cc66' }}>Payment Successful!</h4>
				<p className="text-light mt-3">
					Your subscription has been activated successfully.
				</p>
				<Button variant="primary" className="mt-4" onClick={handleContinue}>
					Continue to Login
				</Button>
			</div>
		);
	}

	function renderMainContent() {
		if(loading) {
			return renderLoading();
		}

		if(error) {
			return renderError();
		}

		return renderSuccess();
	}

	return (
		<Container fluid className="auth-container">
			<Row className="auth-row">
				<Col lg={6} md={8} sm={10}>
					<Card className="p-4 shadow-lg text-center bg-dark text-light border-secondary">
						<Card.Body>
							<h3 className="mb-4" style={{ color: '#f5f5f5' }}>
								Subscription Confirmed
							</h3>
							{renderMainContent()}
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default PaymentSuccessView;
